import { Badge, Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import Card from 'components/card/Card';
import { User } from 'services/@types';
import { formatLastSeen } from './analyticsUtils';
import { useNavigate } from 'react-router-dom';

interface Props {
  users: User[];
}

export default function RecentUsersCard({ users }: Props) {
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const navigate = useNavigate();

  return (
    <Card p="20px" flex="1" minW="300px">
      <Text color={textColor} fontSize="lg" fontWeight="700" mb="16px">
        10 Recent Users
      </Text>
      {users.length === 0 && (
        <Text color="gray.400" fontSize="sm">No data</Text>
      )}
      {users.slice(0, 10).map((u, i) => (
        <Flex
          key={u.id || i}
          justify="space-between"
          align="center"
          py="8px"
          borderBottom="1px solid"
          borderColor="gray.100"
          cursor="pointer"
          _hover={{ bg: 'gray.50' }}
          onClick={() => u.id && navigate(`/admin/brilliant_users/detail/${u.id}`)}
        >
          <Box>
            <Text color={textColor} fontSize="sm" fontWeight="600">
              {[u.firstName, u.lastName].filter(Boolean).join(' ') || u.email || '-'}
            </Text>
            <Text color="gray.400" fontSize="xs">
              {u.email}
            </Text>
          </Box>
          <Flex align="center" gap="8px">
            <Badge colorScheme="purple" fontSize="xs">
              {u.roles?.[0] || 'user'}
            </Badge>
            <Text color="gray.400" fontSize="xs">
              {formatLastSeen(u.createdAt as string)}
            </Text>
          </Flex>
        </Flex>
      ))}
    </Card>
  );
}
